module.exports = __webpack_public_path__ + "static/media/thegfb-home.fd103158.jpg";